import { render, staticRenderFns } from "./ProdutosPorFilial.vue?vue&type=template&id=86b1b18a&scoped=true"
import script from "./ProdutosPorFilial.vue?vue&type=script&lang=js"
export * from "./ProdutosPorFilial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b1b18a",
  null
  
)

export default component.exports